const initialState = { userDetail: [], isLoading: false, updateResponse: "" };

export const profileReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case 'PROFILE_GET_REQUEST':
            return {
                ...state,
                isLoading: action.payload.isLoading,
            }
        case 'PROFILE_GET_RESPONSE':

            return {
                ...state,
                isLoading: action.payload.isLoading,
                userDetail: action.payload.userDetail
            }

        case 'PROFILE_UPDATE_RESPONSE':
            return {
                ...state,
                isLoading: action.payload.isLoading,
                updateResponse: action.payload.updateResponse
            }

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/ProfileReducer.js